import { GetServerSideProps } from 'next'
import { serverSideTranslations } from '../src/utils/convergence'
import React from 'react'
import { withPublic } from '../src/component'
import { getLayout } from '../src/layouts/MainLayout'
import { CheckoutPage } from '../src/model'
import { LoginPage as Login } from '../src/page'
import { getTheme } from '../src/utils/server/convergence'

const I18N_NAMESPACE = ['common', 'terminalError', 'login', 'password', 'verify', 'signUp']

const LoginPage: CheckoutPage = (props) => <Login {...props} />

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { theme } = await getTheme(context)
  return {
    props: {
      theme,
      ...(await serverSideTranslations(context.locale as string, I18N_NAMESPACE)),
    },
  }
}

const LoginPagePublic: CheckoutPage = withPublic(LoginPage)
LoginPagePublic.getLayout = getLayout()

export default LoginPagePublic
